// Returns true if the element's start has to snap, false if the element's end has to snap
const snapStart = (time: number, duration: number, timeToSnap: number): boolean => {
  const diffStart = Math.abs(time - timeToSnap);
  const diffEnd = Math.abs((time + duration) - timeToSnap);
  return diffStart < diffEnd;
};

export default snapStart;
